import { FC, memo } from 'react';
import dayjs from 'dayjs';
import { List, ListItem, Box, Link, Stack, Typography } from '@mui/material';
import Favorite from '@mui/icons-material/Favorite';

export const Footer: FC = memo(() => (
	<Box
		component="footer"
		sx={{
			py: { xs: 2, sm: 1 },
			zIndex: 2,
			position: 'relative',
			width: '100%',
			bgcolor: 'background.paper',
			borderTop: '1px solid',
			borderColor: 'divider',
			boxSizing: 'border-box',
		}}
	>
		<Stack
			direction={{ xs: 'column', sm: 'row' }}
			spacing={2}
			alignItems={{ xs: 'flex-start', sm: 'center' }}
			justifyContent="space-between"
			sx={{
				px: { xs: 1, sm: 2 },
				mx: 'auto',
				width: '100%',
			}}
		>
			<List sx={{ display: 'flex', flexDirection: 'row', m: 0, p: 0 }}>
				<ListItem sx={{ display: 'inline-block', p: 0, width: 'auto' }}>
					<Link
						href="https://pharmacymarketplace.com/privacy-policy/"
						rel="noreferrer"
						target="_blank"
						sx={{
							color: 'inherit',
							px: 2,
							fontWeight: 500,
							fontSize: 12,
							textTransform: 'uppercase',
							borderRadius: 1,
							textDecoration: 'none',
							'&:hover': { textDecoration: 'underline' },
						}}
					>
						Privacy Policy
					</Link>
				</ListItem>
				<ListItem sx={{ display: 'inline-block', p: 0, width: 'auto' }}>
					<Link
						href="https://pharmacymarketplace.com/#athenaPower"
						rel="noreferrer"
						target="_blank"
						sx={{
							color: 'inherit',
							px: 2,
							fontWeight: 500,
							fontSize: 12,
							textTransform: 'uppercase',
							borderRadius: 1,
							textDecoration: 'none',
							'&:hover': { textDecoration: 'underline' },
						}}
					>
						Athena
					</Link>
				</ListItem>
				<ListItem sx={{ display: 'inline-block', p: 0, width: 'auto' }}>
					<Link
						href="https://pharmacymarketplace.com/#testimonials"
						rel="noreferrer"
						target="_blank"
						sx={{
							color: 'inherit',
							px: 2,
							fontWeight: 500,
							fontSize: 12,
							textTransform: 'uppercase',
							borderRadius: 1,
							textDecoration: 'none',
							'&:hover': { textDecoration: 'underline' },
						}}
					>
						Testimonials
					</Link>
				</ListItem>
			</List>
			<Typography
				variant="body2"
				sx={{
					display: 'flex',
					alignItems: 'center',
					fontSize: 12,
					flexWrap: 'wrap',
					py: { xs: 1, sm: 0 },
				}}
			>
				&copy; {dayjs().year()}, made with{' '}
				<Favorite sx={{ width: 18, height: 18, position: 'relative', top: 0, color: '#ec407a', mx: 0.5 }} /> by{' '}
				<Link
					href="https://pharmacymarketplace.com"
					rel="noreferrer"
					target="_blank"
					sx={{ color: '#1e88e5', textDecoration: 'none', ml: 0.5, '&:hover': { textDecoration: 'underline' } }}
				>
					Pharmacy Marketplace Inc.
				</Link>{' '}
				for a better pharmaceutical industry.
			</Typography>
		</Stack>
	</Box>
));
